module.exports = __webpack_public_path__ + "img/Sistema-Administrador-de-Formatos.f64017d2.svg";